import Api from '../services/api.js'

export function fetchFuelTrackersRequest(){
  return {
    type: 'FETCH_FUEL_TRACKERS_REQUEST'
  }
}

export function fetchFuelTrackersSuccess(body){
  return {
    type: 'FETCH_FUEL_TRACKERS_SUCCESS',
    body: body
  }
}

export function fetchFuelTrackersFailure(exception){
  return {
    type: 'FETCH_FUEL_TRACKERS_FAILURE',
    exception: exception
  }
}

export function createFuelTrackerRequest(){
  return {
    type: 'CREATE_FUEL_TRACKER_REQUEST'
  }
}

export function createFuelTrackerSuccess(body){
  return {
    type: 'CREATE_FUEL_TRACKER_SUCCESS',
    body: body
  }
}

export function createFuelTrackerFailure(exception){
  return {
    type: 'CREATE_FUEL_TRACKER_FAILURE',
    exception: exception
  }
}

export function deleteFuelTrackerRequest(){
  return {
    type: 'DELETE_FUEL_TRACKER_REQUEST'
  }
}

export function deleteFuelTrackerSuccess(body){
  return {
    type: 'DELETE_FUEL_TRACKER_SUCCESS',
    body: body
  }
}

export function deleteFuelTrackerFailure(exception){
  return {
    type: 'DELETE_FUEL_TRACKER_FAILURE',
    exception: exception
  }
}

export function updateFuelTrackerRequest(){
  return {
    type: 'UPDATE_FUEL_TRACKER_REQUEST'
  }
}

export function updateFuelTrackerSuccess(body){
  return {
    type: 'UPDATE_FUEL_TRACKER_SUCCESS',
    body: body
  }
}

export function updateFuelTrackerFailure(exception){
  return {
    type: 'UPDATE_FUEL_TRACKER_FAILURE',
    exception: exception
  }
}

export function clearFuelTrackerStates(){
  return {
    type: 'CLEAR_FUEL_TRACKER_STATES',
  }
}

export function fetchFuelTrackers(data) {
  const api = new Api();

  return dispatch => {
    dispatch(fetchFuelTrackersRequest())
    return api.get("/api/v1/fuel_trackers")
    .then(response => {
      dispatch(fetchFuelTrackersSuccess(response.data))
    })
    .catch(err => {
      dispatch(fetchFuelTrackersFailure(err))
    })
  }
}

export function createFuelTracker(data) {
  const api = new Api();

  return dispatch => {
    dispatch(createFuelTrackerRequest())
    return api.post("/api/v1/fuel_tracker", data)
    .then(response => {
      dispatch(createFuelTrackerSuccess(response.data))
    })
    .catch(err => {
      dispatch(createFuelTrackerFailure(err))
    })
  }
}

export function deleteFuelTracker(id) {
  const api = new Api();

  return dispatch => {
    dispatch(deleteFuelTrackerRequest())
    return api.delete("/api/v1/fuel_tracker/" + id)
    .then(response => {
      dispatch(deleteFuelTrackerSuccess(response.data))
    })
    .catch(err => {
      dispatch(deleteFuelTrackerFailure(err))
    })
  }
}

export function updateFuelTracker(id, data) {
  const api = new Api();

  return dispatch => {
    dispatch(updateFuelTrackerRequest())
    return api.put("/api/v1/fuel_tracker/" + id, data)
    .then(response => {
      dispatch(updateFuelTrackerSuccess(response.data))
    })
    .catch(err => {
      dispatch(updateFuelTrackerFailure(err))
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/fuelTracker.js